import { render, staticRenderFns } from "./infoChangeDetail.vue?vue&type=template&id=1c14cd13&scoped=true"
import script from "./infoChangeDetail.vue?vue&type=script&lang=js"
export * from "./infoChangeDetail.vue?vue&type=script&lang=js"
import style0 from "./infoChangeDetail.vue?vue&type=style&index=0&id=1c14cd13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c14cd13",
  null
  
)

export default component.exports